module.exports = __webpack_public_path__ + "img/app.da53f591.png";